import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DialogService } from 'src/app/core/services/dialog/dialog.service';
import { RoutesKeys } from 'src/app/utils/routes';

@Component({
  selector: 'app-product-info-modal',
  templateUrl: './product-info-modal.component.html',
  styleUrls: ['./product-info-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

/**
 * Modal for Product Overview and its rewards.
 */
export class ProductInfoModalComponent {
  descriptionLabel = 'product-info-description';
  activeTabIndex = 0;
  tabLabels = ['product-overview', 'product-rewards-list'];

  /**
   * Constructor
   */
  constructor(
    private dialogRef: MatDialogRef<ProductInfoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    private dialogService: DialogService
  ) {}

  /**
   * Action to close the dialog
   */
  onDialogClose() {
    this.dialogRef.close();
  }
  /**
   * Navigates to the product edit page and closes the dialog.
   */
  goToProductEdit() {
    this.router.navigate(
      [RoutesKeys.PRODUCT_DETAIL, this.data.productData.id],
      {
        state: { productData: this.data.productData },
      }
    );
    this.dialogRef.close();
  }

  /**
   * Opens the delete reward modal
   * @param {any} reward - The reward to be deleted
   */
  openDeleteReward(reward: any) {
    this.dialogRef.close();

    this.dialogRef.afterClosed().subscribe(() => {
      this.dialogService.openDeleteRewardModal(
        reward,
        () => {
          this.data.acceptAction();
        },
        () => {
          this.dialogService.openProductInfoModal(
            this.data.productData,
            this.data.acceptAction
          );
        }
      );
    });
  }
}
